import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

export type UpdateOrderOptions = {
  /** Defaults to the step the user is on right now. */
  stage?: number
  onSuccess?: () => void
  /**
   * Patch the full order payload — contractor and persons included. Set by the
   * wizard footer, which only moves on once those are valid. A recalculation
   * fired from inside the form leaves it off and patches the pricing fields only.
   */
  withOrderData?: boolean
}

type FinancialInsuranceValues = {
  isEditable: boolean
  order?: OrderDetail
  isCalculatingLoading: boolean
  handleCalculate: (onSuccess: () => void) => Promise<void>
  handleRecalculate: () => void
  handleUpdateOrder: (options?: UpdateOrderOptions) => void
}

const FinancialInsuranceContext = createContext<FinancialInsuranceValues>({
  isEditable: false,
  isCalculatingLoading: false,
  handleCalculate: () => Promise.resolve(),
  handleRecalculate: () => null,
  handleUpdateOrder: () => null
})

export const FinancialInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<FinancialInsuranceValues>) => {
  return (
    <FinancialInsuranceContext.Provider value={values}>
      {children}
    </FinancialInsuranceContext.Provider>
  )
}

export const useFinancialInsuranceValues = () =>
  useContext(FinancialInsuranceContext)
